/**
 * @typedef {Object} Plan
 * @property {string} name
 * @property {string} description
 */

/**
 * @typedef {Object} SubscriptionPlans
 * @property {string} id
 * @property {boolean} isMain
 * @property {string[]} pros
 * @property {Plan} plan
 */

/** @type {SubscriptionPlans[]} */
const subscriptionPlans = [
  {
    id: 'free',
    isMain: false,
    plan: {
      name: 'Darmowe',
      description: 'Idealny dla początkujących dietetyków, zaczynających pracę z pierwszymi pacjentami',
    },
    isAvailableMonthlySettlementPeriodType: true,
    additionalMonthsForAnnualSubscription: 0,
    additionalMonthsForSemiAnnualSubscription: 0,
    functionalities: null,
    pros: [
      'Pełna baza produktów i dań',
      'Kreator jadłospisu',
      'Podstawowe funkcje wyszukiwarki przepisów',
      'Wbudowany, gotowy wywiad żywieniowy',
      'Komentarze do posiłków i jadłospisów',
      'Karta pacjenta (pomiary, notatki z wizyty)',
      'Podstawowy wydruk jadłospisu',
      '20 własnych przepisów i produktów',
      'Do 5 pacjentów',
      'Potrawy wieloporcjowe',
      'Miary domowe i kuchenne',
      'WW, WBT, IG, ŁG',
      'Oznaczania niewskazanych produktów',
      'Oznaczanie powtórzonych potraw',
      'Lista zakupów',
      'Logo i dane dietetyka na wydruku',
    ],
  },
  {
    id: 'student',
    isMain: false,
    plan: {
      name: 'Student',
      description: 'Pakiet dla studentów dietetyki i innych kierunków związanych z żywieniem',
    },
    isAvailableMonthlySettlementPeriodType: false,
    additionalMonthsForAnnualSubscription: 0,
    additionalMonthsForSemiAnnualSubscription: 0,
    functionalities: 'Darmowe',
    pros: [
      '12 wyglądów planów żywieniowych',
      'Nielimitowana ilość własnych produktów i przepisów',
      'Nielimitowana ilość pacjentów',
      'Tworzenie własnych szablonów diet',
      'Kalendarz wizyt',
    ],
  },
  {
    id: 'standard',
    isMain: false,
    plan: {
      name: 'Standard',
      description:
        'Pakiet dla dietetyków, potrzebujących niezbędnych funkcji do układania jadłospisów dla swoich pacjentów',
    },
    isAvailableMonthlySettlementPeriodType: true,
    additionalMonthsForAnnualSubscription: 0,
    additionalMonthsForSemiAnnualSubscription: 0,
    functionalities: 'Darmowe',
    pros: [
      '12 wyglądów planów żywieniowych',
      'Nielimitowana ilość własnych produktów i przepisów',
      'Nielimitowana ilość pacjentów',
      'Tworzenie własnych szablonów diet',
      'Kalendarz wizyt',
    ],
  },
  {
    id: 'premium',
    isMain: true,
    plan: {
      name: 'Premium',
      description:
        'Pakiet dla dietetyków, chcących skrócić czas układania jadłospisów do minimum i kompleksowo obsłużyć pacjentów',
    },
    isAvailableMonthlySettlementPeriodType: true,
    functionalities: 'Standard',
    additionalMonthsForAnnualSubscription: 0,
    additionalMonthsForSemiAnnualSubscription: 0,
    pros: [
      'Aplikacja mobilna dla pacjenta',
      'Moduł edukacyjny - (Webinary z psychodietetyki)',
      'Gotowe zalecenia żywieniowe',
      'Materiały edukacyjne dla pacjentów (zamienniki w diecie i zalecenia żywieniowe przy chorobach)',
      'Tworzenie własnych zaleceń i wywiadów z pacjentem',
      'Udostępnianie swoich materiałów innym dietetykom',
      'Wysyłanie jadłospisów bezpośrednio z programu',
      'Kalendarz wizyt',
      'Skalowanie jadłospisów',
      'Drukowanie diety po posiłkach',
      'Dzielona lista zakupów',
      'Globalna zamiana produktów',
      'Łączenie listy zakupów kilku pacjentów',
      'Kopiowanie całych dni i posiłków',
    ],
  },
];

export const getSubscriptionPlans = (id) => subscriptionPlans.find((subscriptionPlan) => subscriptionPlan.id === id);
